module.exports = __webpack_public_path__ + "img/julien_dore-nouvel_album.235df964.jpg";